export default "__VITE_ASSET__AKavtx3S__"